import { useSelector } from 'react-redux';

import { pageNames } from '@atc/bonnet-paths';
import { useFeatures } from '@atc/features';

import useIsIndexable from '@/utilities/useIsIndexable';

import srpContentDuck from '@/ducks/srp/srpContentDuck';

import CanonicalUrlModule from '@/modules/CanonicalUrlModule';

const { SEARCH_RESULTS } = pageNames;

export default function useCustomContent(pageName = SEARCH_RESULTS) {
    const {
        enable_srp_altezza_custom_content: [enableAltezzaCustomContent],
    } = useFeatures([
        'enable_srp_altezza_custom_content',
    ]);

    const isEnableCustomContent = useSelector(srpContentDuck.selectors.isEnableCustomContent);
    const canonicalUrl = useSelector(CanonicalUrlModule.duck.selectors.getDuckState);
    const isIndexable = useIsIndexable(canonicalUrl, pageName);

    return {
        isEnableCustomContent: enableAltezzaCustomContent && isEnableCustomContent && isIndexable,
        canonicalUrl,
        isIndexable,
    };
}
